/**
 * Curated personality traits — closed vocab with Lucide icons.
 *
 * Limited to ~30 self-descriptors that are usable for partner-fit
 * matching without becoming a vanity contest. Adjectives only — no
 * value statements ("religious", "successful") that turn the profile
 * into a sales pitch.
 */

import type { TraitOption } from '../types.js';

export const PERSONALITY_OPTIONS: readonly TraitOption[] = [
  { value: 'ambitious', labelKey: 'personality.ambitious', icon: 'target' },
  { value: 'curious', labelKey: 'personality.curious', icon: 'compass' },
  { value: 'thoughtful', labelKey: 'personality.thoughtful', icon: 'brain' },
  { value: 'easygoing', labelKey: 'personality.easygoing', icon: 'smile' },
  { value: 'introvert', labelKey: 'personality.introvert', icon: 'circle-dashed' },
  { value: 'extrovert', labelKey: 'personality.extrovert', icon: 'users' },
  { value: 'ambivert', labelKey: 'personality.ambivert', icon: 'shuffle' },
  { value: 'patient', labelKey: 'personality.patient', icon: 'hourglass' },
  { value: 'kind', labelKey: 'personality.kind', icon: 'heart' },
  { value: 'family_oriented', labelKey: 'personality.family_oriented', icon: 'home' },
  { value: 'adventurous', labelKey: 'personality.adventurous', icon: 'map' },
  { value: 'creative', labelKey: 'personality.creative', icon: 'palette' },
  { value: 'analytical', labelKey: 'personality.analytical', icon: 'function-square' },
  { value: 'humorous', labelKey: 'personality.humorous', icon: 'laugh' },
  { value: 'organized', labelKey: 'personality.organized', icon: 'list-checks' },
  { value: 'spontaneous', labelKey: 'personality.spontaneous', icon: 'zap' },
  { value: 'optimistic', labelKey: 'personality.optimistic', icon: 'sun' },
  { value: 'realist', labelKey: 'personality.realist', icon: 'square-equal' },
  { value: 'romantic', labelKey: 'personality.romantic', icon: 'flower-2' },
  { value: 'private', labelKey: 'personality.private', icon: 'lock' },
  { value: 'communicative', labelKey: 'personality.communicative', icon: 'message-circle' },
  { value: 'spiritual', labelKey: 'personality.spiritual', icon: 'sparkle' },
  { value: 'disciplined', labelKey: 'personality.disciplined', icon: 'shield-check' },
  { value: 'gentle', labelKey: 'personality.gentle', icon: 'feather' },
  { value: 'direct', labelKey: 'personality.direct', icon: 'arrow-right' },
  { value: 'reflective', labelKey: 'personality.reflective', icon: 'mirror' },
  { value: 'generous', labelKey: 'personality.generous', icon: 'hand-heart' },
  { value: 'principled', labelKey: 'personality.principled', icon: 'scale' },
  { value: 'playful', labelKey: 'personality.playful', icon: 'gamepad-2' },
  { value: 'devout', labelKey: 'personality.devout', icon: 'moon-star' },
] as const;

export const PERSONALITY_VALUES: ReadonlySet<string> = new Set(
  PERSONALITY_OPTIONS.map((o) => o.value),
);
